var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.785,
    height: 15,
    viewBox: "0 0 11.785 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Employee",
    d: "M85.892,31.99A3.215,3.215,0,1,0,89.108,35.2a3.223,3.223,0,0,0-3.216-3.214v0Zm-1.071,7.5A4.823,4.823,0,0,0,80,44.311V46.99H91.785V44.311a4.823,4.823,0,0,0-4.819-4.821.537.537,0,0,0-.521.666l1,3.991L85.892,45.7l-1.549-1.549,1-3.991a.537.537,0,0,0-.52-.668v0Z",
    transform: "translate(-80 -31.99)",
    fill: "#2C5DFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeBtn);
export default __webpack_public_path__ + "static/media/EmployeeBtn.ff0e4cfa7bd6c0480648f12d0b10bb76.svg";
export { ForwardRef as ReactComponent };